import { Box, CardMedia, Paper, Typography } from '@mui/material';
import Cookies from 'js-cookie';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { convertCurrency } from '../../../utils/convertCurrency';

export default function AboutPackage({ packageData }) {
    const { currency } = useSelector(state => state.currency);
    const { t } = useTranslation();
    const lang = Cookies.get("i18next") || "en";

    function convertDate(dateString) {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0]; // yyyy-mm-dd
    }

    const [convertedAmount, setConvertedAmount] = React.useState(null);

    React.useEffect(() => {
        async function fetchConvertedAmount() {
            const result = await convertCurrency(packageData?.price, packageData?.currency, currency);
            setConvertedAmount(result);
        }

        fetchConvertedAmount();
    }, [packageData?.price, currency, packageData?.currency]);

    const ResponsiveRow = ({ label, value, color = "inherit" }) => (
        <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px"
            }}
        >
            <Typography
                variant="body1"
                sx={{
                    width: { xs: "100%", sm: "45%", md: "300px" },
                    textAlign: "center",
                    padding: "1rem",
                    background: "#f2f3f4",
                    borderRadius: "1rem",
                    fontWeight: "700"
                }}
            >
                {label}
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    width: { xs: "100%", sm: "45%", md: "300px" },
                    textAlign: "center",
                    padding: "1rem",
                    background: "#f2f3f4",
                    borderRadius: "1rem",
                    fontWeight: "400",
                    color
                }}
            >
                {value}
            </Typography>
        </Box>
    );

    return (
        <Paper sx={{ padding: { xs: "24px 16px", md: "32px 24px" }, marginY: "30px" }}>
            <CardMedia
                component="img"
                image={packageData?.image ? `${process.env.REACT_APP_API_KEY}images/${packageData?.image}` : "/logo.png"}
                alt="package img"
                sx={{
                    filter: "brightness(50%)",
                    height: { xs: "200px", sm: "300px", md: "400px" },
                    width: "100%",
                    objectFit: "cover",
                    borderRadius: "8px"
                }}
            />
            <Typography
                variant="h4"
                sx={{ marginTop: "16px", marginBottom: "8px", fontWeight: "700" }}
            >
                {lang === "ar" ? packageData?.titleAr : packageData?.titleEn}
            </Typography>
            <Typography
                variant="body1"
                sx={{ marginBottom: "20px", fontWeight: "400" }}
            >
                {lang === "ar" ? packageData?.descriptionAr : packageData?.descriptionEn}
            </Typography>

            <ResponsiveRow
                label={t("level")}
                value={lang === "ar" ? packageData?.level?.titleAR : packageData?.level?.titleEN}
                color="#5dade2"
            />
            <ResponsiveRow
                label={t("classes")}
                value={lang === "ar" ? packageData?.classId?.titleAR : packageData?.classId?.titleEN}
                color="#5dade2"
            />
            <ResponsiveRow
                label={t("studyCurriculum")}
                value={lang === "ar" ? packageData?.curriculums?.titleAR : packageData?.curriculums?.titleEN}
                color="#5dade2"
            />
            <ResponsiveRow
                label={t("level")}
                value={t(packageData?.semester)}
                color="#5dade2"
            />
            <ResponsiveRow
                label={t("packageType")}
                value={t(packageData?.packageType)}
                color="#5dade2"
            />
            <ResponsiveRow
                label={t("Package Price")}
                value={
                    convertedAmount !== null ? `${convertedAmount} ${t(currency)}` : "Loading..."
                }
                color="#5dade2"
            />
            <ResponsiveRow
                label={t("startDate")}
                value={convertDate(packageData?.startDate)}
                color="#5dade2"
            />
            <ResponsiveRow
                label={t("End Date")}
                value={convertDate(packageData?.endDate)}
                color="#ec7063"
            />
            <ResponsiveRow
                label={t("sharesCount")}
                value={packageData?.numberOfShares}
                color="#5dade2"
            />
            <ResponsiveRow
                label={t("sharesCountInWeek")}
                value={packageData?.sharesInWeek}
                color="#5dade2"
            />
        </Paper>
    );
}
